import { render, staticRenderFns } from "./directInvest_Opportunities_Details_Pdf.vue?vue&type=template&id=728a661b&scoped=true"
import script from "./directInvest_Opportunities_Details_Pdf.vue?vue&type=script&lang=js"
export * from "./directInvest_Opportunities_Details_Pdf.vue?vue&type=script&lang=js"
import style0 from "./directInvest_Opportunities_Details_Pdf.vue?vue&type=style&index=0&id=728a661b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a661b",
  null
  
)

export default component.exports